import { requestGet, requestPost } from '@/utils/request';

const api = {
    LIST: '/member/agent_list',
    ADD: '/member/agent_add',
    UPDATE: '/member/agent_update',
    SET_ENABLE: '/member/agent_set_enable',
    RESET_PASSWORD: '/member/agent_reset_password',
    IS_EXIST_ACCOUNT: '/member/agent_is_exist_account',
    AREA_OPTIONS: '/member/agent_area_options',
    BIND_GOOGLE_AUTH: '/member/agent_bind_google_auth',
    BIND_GOOGLE_AUTH_PRO: '/member/agent_bind_google_auth_pro',
    UNBIND_GOOGLE_AUTH: '/member/agent_unbind_google_auth'
};

export function agentList(params) {
    return requestGet(api.LIST, params);
}

export function agentAdd(form) {
    return requestPost(api.ADD, form);
}

export function agentUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export function agentSetEnable(id, isEnable) {
    return requestPost(api.SET_ENABLE, { id, isEnable });
}

export function agentResetPassword(form) {
    return requestPost(api.RESET_PASSWORD, form);
}

export function agentAccountIsExist(account) {
    return requestGet(api.IS_EXIST_ACCOUNT, { val: account });
}

export function agentAreaOptions(excludeId) {
    return requestGet(api.AREA_OPTIONS, { excludeId: excludeId || 0 });
}

export function agentBindGoogleAuth(id) {
    return requestGet(api.BIND_GOOGLE_AUTH, { id });
}

export function agentBindGoogleAuthPro(params) {
    return requestPost(api.BIND_GOOGLE_AUTH_PRO, params);
}

export function agentUnbindGoogleAuth(id) {
    return requestPost(api.UNBIND_GOOGLE_AUTH, { id });
}
